import { DynamicLabradorComponents } from '@/components/labrador';
import { DynamicLabradorArticleTeaserDefault } from '@/components/labrador/ArticleTeaser/Default';
import { LabradorComponent } from '@/types/component';
import { pathToComponent } from '@/utils/index';
import withDebugMetadata from '@/utils/withDebugMetadata';

export const LabradorArticleTeaser: LabradorComponent = ({ type, data, meta, descendants }) => {
  const name = 'ArticleTeaser' + (pathToComponent(meta.path) || 'Default');
  const key = name as keyof typeof DynamicLabradorComponents;
  const ArticleTeaser = DynamicLabradorComponents[key] || DynamicLabradorArticleTeaserDefault;

  return <ArticleTeaser {...{ type, data, meta, descendants }} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorArticleTeaser;
